import React, { useState } from "react";
import { toast } from "react-toastify";
import { submitContactForm } from "../../services/contactService";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Your name is required";
    }

    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(form.email)) {
        newErrors.email = "Enter a valid email address";
      }
    }

    if (!form.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else {
      const mobileRegex = /^[6-9]\d{9}$/;
      if (!mobileRegex.test(form.mobile)) {
        newErrors.mobile = "Enter a valid 10-digit mobile number";
      }
    }

    if (!form.message.trim()) {
      newErrors.message = "Message cannot be empty";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true); // ✅ START LOADER

        const payload = {
          name: form.name,
          email: form.email,
          mobile: form.mobile,
          message: form.message,
        };

        const res = await submitContactForm(payload);

        if (res?.status === 200) {
          toast.success(res?.message || "Message sent successfully!");
          setForm({ name: "", email: "", mobile: "", message: "" });
        } else {
          toast.error("Something went wrong!");
        }
      } catch (error) {
        toast.error(error?.message || "Failed to send message");
      } finally {
        setLoading(false); // ✅ STOP LOADER
      }
    }
  };

  return (
    <div>

      {/* ================= CONTACT BANNER ================= */}
      <div style={styles.banner}>
        <img
          src={require("../assets/ContactUs.png")}
          alt="Contact Us"
          style={styles.bannerImg}
        />
      </div>

      {/* ================= CONTENT ================= */}
      <div style={styles.wrapper}>

        {/* HEADER */}
        <div style={styles.headerText}>
          <p style={styles.smallTitle}>GET IN TOUCH</p>
          <h2 style={styles.mainTitle}>
            We'd love to hear from you, Reach out anytime.
          </h2>
          <p style={styles.desc}>
            Have questions or need assistance? Fill out the form and we’ll get
            back to you within 24 hours.
          </p>
        </div>
      </div>

      {/* GRID */}
      <div style={styles.grid}>
        {/* FORM */}
        <div style={styles.card}>
          <form onSubmit={handleSubmit} noValidate>
            <label style={styles.label}>Your Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              style={{
                ...styles.input,
                borderColor: errors.name ? "red" : "#ddd"
              }}
              value={form.name}
              onChange={handleChange}
            />
            {errors.name && <p style={styles.error}>{errors.name}</p>}

            <label style={styles.label}>Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              style={{
                ...styles.input,
                borderColor: errors.email ? "red" : "#ddd"
              }}
              value={form.email}
              onChange={handleChange}
            />
            {errors.email && <p style={styles.error}>{errors.email}</p>}

            <label style={styles.label}>Mobile Number</label>
            <input
              type="text"
              name="mobile"
              placeholder="Enter your mobile number"
              style={{
                ...styles.input,
                borderColor: errors.mobile ? "red" : "#ddd"
              }}
              value={form.mobile}
              onChange={handleChange}
              maxLength={10}
            />
            {errors.mobile && <p style={styles.error}>{errors.mobile}</p>}

            <label style={styles.label}>Your Message</label>
            <textarea
              name="message"
              placeholder="How can we help you?"
              style={{
                ...styles.textarea,
                borderColor: errors.message ? "red" : "#ddd"
              }}
              value={form.message}
              onChange={handleChange}
            />
            {errors.message && <p style={styles.error}>{errors.message}</p>}

            <button
              type="submit"
              style={{
                ...styles.button,
                opacity: loading ? 0.8 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
              disabled={loading}
            >
              {loading ? (
                <div style={styles.btnLoaderWrapper}>
                  <div style={styles.loader}></div>
                  Sending...
                </div>
              ) : (
                "Send Message"
              )}
            </button>
          </form>
        </div>

        {/* CONTACT INFO */}
        <div style={styles.card}>
          <h3 style={styles.infoTitle}>Contact Information</h3>

          <div style={styles.infoItem}>
            <span>📧</span>
            <div>
              <p style={styles.infoHead}>Email Us</p>
              <a href="mailto:support@nanopulse.in">
                support@nanopulse.in
              </a>
            </div>
          </div>

          <div style={styles.infoItem}>
            <span>📞</span>
            <div>
              <p style={styles.infoHead}>Call Us</p>
              <a
                href="tel:+919668246683"
                style={{
                  color: "#2f66b1",
                  textDecoration: "none",
                  fontWeight: "500"
                }}
              >
                +91 9668246683
              </a>
            </div>
          </div>

          <div style={styles.infoItem}>
            <span>📍</span>
            <div>
              <p style={styles.infoHead}>Visit Us</p>
              <p>Bhubaneswar, Odisha, India</p>
            </div>
          </div>

          {/* MAP */}
          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13840.778760533216!2d85.80588173955945!3d20.360450175390966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1908e025984c55%3A0xee1fcd1f11e55141!2sDLF%20Cyber%20City!5e0!3m2!1sen!2sin!4v1751365013905!5m2!1sen!2sin"
            style={styles.map}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;

const styles = {
  wrapper: {
    padding: "60px 30px",
    maxWidth: "1200px",
    margin: "auto"
  },

  banner: {
    position: "relative",
    width: "100%",
    height: "400px",
    overflow: "hidden"
  },

  bannerImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block"
  },

  headerText: {
    textAlign: "center",
    marginBottom: "40px",
    marginTop: "40px"
  },
  smallTitle: {
    color: "#2f66b1",
    fontWeight: "bold",
    letterSpacing: "2px"
  },
  mainTitle: {
    fontSize: "32px",
    margin: "10px 0"
  },
  desc: {
    color: "#555"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "30px"
  },
  card: {
    background: "#fff",
    padding: "25px",
    borderRadius: "10px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.08)"
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontWeight: "500"
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "5px",
    borderRadius: "6px",
    border: "1px solid #ddd"
  },
  textarea: {
    width: "100%",
    padding: "12px",
    height: "120px",
    borderRadius: "6px",
    border: "1px solid #ddd",
    marginBottom: "5px"
  },
  button: {
    width: "100%",
    padding: "14px",
    background: "#2f66b1",
    color: "#fff",
    border: "none",
    borderRadius: "30px",
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "10px"
  },
  error: {
    color: "red",
    fontSize: "13px",
    marginBottom: "10px"
  },
  infoTitle: {
    marginBottom: "20px",
    color: "#2f66b1"
  },
  infoItem: {
    display: "flex",
    gap: "12px",
    marginBottom: "15px"
  },
  infoHead: {
    fontWeight: "600"
  },
  map: {
    width: "100%",
    height: "200px",
    border: "0",
    marginTop: "15px",
    borderRadius: "8px"
  },
  loader: {
    width: "20px",
    padding: "4px",
    aspectRatio: "1",
    borderRadius: "50%",
    background: "#fff",
    WebkitMask:
      "conic-gradient(#0000 10%,#000), linear-gradient(#000 0 0) content-box",
    mask:
      "conic-gradient(#0000 10%,#000), linear-gradient(#000 0 0) content-box",
    WebkitMaskComposite: "source-out",
    maskComposite: "subtract",
    animation: "spinLoader 1s infinite linear",
  },
  btnLoaderWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  }
};